import { render, staticRenderFns } from "./MediaModal.vue?vue&type=template&id=494402a2&"
import script from "./MediaModal.vue?vue&type=script&lang=js&"
export * from "./MediaModal.vue?vue&type=script&lang=js&"
import style0 from "./MediaModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports